export function getPhotoCount(preset) {
  return Number(preset?.photoCount) === 2 ? 2 : 1;
}
